import { AxiosRequest } from "../../../../Url";
import { getRightsData } from "../../../Tools/Tools";
import { mfEdit } from "../../rcsgrid";
import { orgGetImage } from "./orgGetImage";
import { ObjType as ObjectType } from "../../../Tools/Consts";
import { CreateCollapsibleRecords, isCollapsibleRecord } from "../../GridTools/collapsibleRecordsTools";

const mainOrgImageIndex = 84;
// Булево поле приходит с сервера текстом "Да"/"Нет" либо значением "1"/"0"
const falseBooleanTexts = ["", "0", "нет", "false"];
const isTrueText = (text) => !falseBooleanTexts.includes(String(text ?? "").toLowerCase());

export async function groupingOrg(grid, source, props, data) {
  source.onHandleRequest = HandleJoinedFunc(data.ObjType);
  source.rights = getRightsData(2);
  source.CreateCollapsibleRecords = CreateCollapsibleRecords;

  grid.setColumns(data.Columns);
  if (Number(data.ObjType) === ObjectType.Organization) {
    // Иконки как в тонком клиенте (TfJoinOrgs.cgTableGetImageIndex): статус по ExternalKey и признак главной организации
    grid.setImageFields(["ExternalKey", "Main"]);
    source.booksGetImage = (value, field) => {
      if (field !== "Main") return orgGetImage(value, field);
      return isTrueText(value) ? mainOrgImageIndex : 0;
    };
    // У выбранной (главной) записи чекбокса нет
    grid.changeGridStyles = (row) => {
      const checkBox = row.querySelector('div[role="check-box"]');
      if (checkBox) checkBox.style.display = isTrueText(source.getFieldTextSync("Main", row.recordIndex)) ? "none" : "";
    };
  }
  // Список найденных дублей только для чтения: редактируется лишь чекбокс, вставка и удаление запрещены
  grid.canModify = (flag, column, gridArg) => {
    if (!gridArg.localCanModify(flag, column, gridArg)) return false;
    return flag === mfEdit && column?.fieldName === "None" && !isTrueText(source.getFieldTextSync("Main"));
  };
  grid.panel.ondblclick = async (event) => {
    if (event.target.closest("td")?.field?.fieldName !== "OrgName" || event.target.closest("#ExpandIcon")) return;
    const recordState = await source.getRecordState();
    if (isCollapsibleRecord(recordState)) {
      // После await у события currentTarget уже null, а onRecordCollapsed читает из него атрибут recordindex
      await source.onRecordCollapsed({ currentTarget: grid.panel });
      return;
    }
    const id = source.getFieldTextSync("ID");
    await joinChangeOrgReq(data.ObjType, id);
    await grid.refreshSource();
  };
  source.onRecordCollapsed = async function (event) {
    let RecordIndex,
      RecordState = await source.getRecordState();
    if (event.currentTarget !== undefined) {
      RecordIndex = event.currentTarget.getAttribute("recordindex");
    } else {
      RecordIndex = await event;
    }
    await HandleJoinedFunc(data.ObjType)({
      command: "CollapseGroup",
      collapsed: RecordState & 128 ? undefined : "1",
      recordindex: RecordIndex ? RecordIndex : undefined,
    });

    await grid.refreshSource("!");
  };
  await source.open();

  await source.refresh();
  await grid.setSource(source);
  await grid.updateGridSize();
}

function HandleJoinedFunc(ObjType) {
  return function HandleJoin(request) {
    let param = new Map();
    param.set("prefix", "organizations").set("comand", "HandleJoined").set("ObjType", ObjType);
    return AxiosRequest(false, param, request);
  };
}

const joinChangeOrgReq = (objType, id) => {
  const param = new Map();
  param.set("prefix", "organizations").set("comand", "JoinChangeOrg").set("ObjType", objType).set("id", id);
  return AxiosRequest(true, param);
};
